import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ActionButton from 'components/common/ActionButton';
import PageHeader from 'components/common/PageHeader';

const ListHomeBanners = () => {
  const [homeBanners, setHomeBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setError(null);
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/banners/list`
        );
        console.log(response.data);
        setHomeBanners(response.data.data);
      } catch (error) {
        console.log('error', error);
        setError(error.message);
      } finally {
        console.log('finally');
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const archiveBanner = async (id, title) => {
    if (id != null && title) {
      if (
        window.confirm(`Are you sure you want to delete this banner: ${title}?`)
      ) {
        try {
          setError(null);
          const response = await axios.put(
            `${process.env.REACT_APP_API_URL}/banners/archive/id/${id}`
          );
          console.log(response.data);
          setHomeBanners(homeBanners.filter((event) => event.id !== id));
        } catch (error) {
          console.log('error', error);
          setError(error.message);
        }
      }
    }
  };

  return (
    <>
      <PageHeader
        title='Homepage Banners'
        description=''
        className='mb-3'
      ></PageHeader>
      {loading ? (
        <div>Loading...</div>
      ) : error ? (
        <div>Error: {error}</div>
      ) : (
        <Table hover responsive>
          <thead>
            <tr>
              <th scope='col'>Title</th>
              <th scope='col'>Date Added</th>
              <th className='text-end' scope='col'>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {homeBanners.map((item, index) => (
              <tr key={index}>
                <td>
                  <Link to={`/banner/${item.id}`}>{item.title}</Link>
                </td>
                <td>{item.date_added}</td>
                <td className='text-end'>
                  <Link to={`/banners/edit/${item.id}`}>
                    <ActionButton
                      icon='edit'
                      title='Edit'
                      variant='action'
                      className='p-0 me-2'
                    />
                  </Link>
                  <ActionButton
                    icon='trash-alt'
                    title='Delete'
                    variant='action'
                    className='p-0'
                    onClick={() => archiveBanner(item.id, item.title)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default ListHomeBanners;
